// extracted by mini-css-extract-plugin
export default {"addon":"TabAddon_addon__8dPRr"};